export default __webpack_public_path__ + "static/media/map2.4ac4f949.png";